var a="uk",u=["uk"];export{a as defaultLanguage,u as supportedLngs};
//# sourceMappingURL=constants.js.map